import { createContext, useContext } from 'react';

const SiteContext = createContext({ healthcareOnly: false, basePath: '' });

export const useSiteContext = () => useContext(SiteContext);

export default SiteContext;